import React from 'react'
import styled from 'styled-components'
import { Paper, TextField } from '@material-ui/core'

import useWindowSize from '@rehooks/window-size'

const SelectListPaper = styled(Paper)`
  position: relative;
  overflow: auto;
  padding: 0;
`
const ListNameTextField = styled(TextField)`
  width: 70%;
`

const SelectListEditer: React.FC = () => {
  const windowSize = useWindowSize()
  const workHeight = windowSize.innerHeight - 64

  return (
    <SelectListPaper style={{height: workHeight}} elevation={0} square>
      <form>
        <ListNameTextField defaultValue="リスト２" variant="outlined" />
      </form>
    </SelectListPaper>
  )
}

export default SelectListEditer
